export interface IPhoto {
    index: number,
    currentFile: string,
    newFile: File,
    remove: boolean
}